import { Lock, Shield, RefreshCcw } from "lucide-react";

/**
 * Trust strip — three commitments that matter most to patients/caregivers
 * about to share sensitive health data. Available in two variants:
 *   - "light" (default): lime-tinted pills on white/gray background
 *   - "dark": lime-tinted pills on dark navy background (for use in hero strips)
 */
export function TrustBar({ variant = "light" }) {
  const items = [
    { Icon: Lock, label: "Encrypted & private" },
    { Icon: Shield, label: "GDPR compliant" },
    { Icon: RefreshCcw, label: "Withdraw anytime" },
  ];
  const isDark = variant === "dark";
  const chipCls = isDark
    ? "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/[0.06] border border-[var(--lime)]/30 text-[13px] font-semibold text-white"
    : "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[var(--lime)]/15 border border-[var(--lime)]/30 text-[13px] font-semibold text-[var(--charcoal)]";
  const iconCls = isDark ? "text-[var(--lime)]" : "text-[var(--teal)]";
  return (
    <div
      className={`flex flex-wrap items-center ${
        isDark ? "justify-start" : "justify-center"
      } gap-2`}
      data-testid="trust-bar"
    >
      {items.map(({ Icon, label }) => (
        <span key={label} className={chipCls}>
          <Icon size={13} className={iconCls} strokeWidth={2.5} />
          {label}
        </span>
      ))}
    </div>
  );
}

export default TrustBar;
